import { ref } from 'vue';
import type { PFSNotification } from '~/app/types/notificationType';
import { useActiveNotifications } from '~/composables/notifications/useNotifications';

const orders = ref<PFSNotification[]>([]);
const modifications = ref<PFSNotification[]>([]);
const cancellations = ref<PFSNotification[]>([]);
const expired = ref<PFSNotification[]>([]);

const refreshActiveNotifications = async (floristId: string | undefined, isInternalUser: boolean) => {
  const notifications = await useActiveNotifications(floristId, isInternalUser);
  orders.value = notifications.orders;
  modifications.value = notifications.modifications;
  cancellations.value = notifications.cancellations;
  expired.value = notifications.expired ?? [];
};

export function useActiveNotificationsState() {
  return {
    orders,
    modifications,
    cancellations,
    expired,
    refreshActiveNotifications,
  };
}
